import { CodeTypeModel }                 from '../../app-lite/core/models/code-type';
import { CompanyCustomizationsModel }    from './models/company.customizations';
import { CompanyCustomizationsService }  from './company.customizations.service';
import { CustomerMessagesSettingsModel } from '../../app-lite/messages/customer-messages/typings/customer-messages.settings';

interface CompanyCustomizationsScope extends ng.IScope {
  company                      : any;
  customizations               : CompanyCustomizationsModel;
  customerMessagesForm         : ng.IFormController;
  customerMessagesSettings     : CustomerMessagesSettingsModel;
  brandingGroups               : Array<CodeTypeModel>;
  init                         : () => void;
  integrationsForm             : ng.IFormController;
  saveBranding                 : () => void;
  saveCustomerMessagesSettings : () => void;
  saveStripeFee                : () => void;
  setDataDefaults              : () => void;
  setDefaults                  : () => void;
}

export function CompanyCustomizationsCtrl (
  $state                  : ng.ui.IStateService,
  $stateParams            : ng.ui.IStateParamsService,
  $scope                  : CompanyCustomizationsScope,
  $translate              : ng.translate.ITranslateService,
  confirm                 : any,
  companyCustomizationsApi: CompanyCustomizationsService,
  messages                : any
) {
  $scope.brandingGroups           = [];
  $scope.customerMessagesSettings = {};
  $scope.customizations           = {};

  $scope.init = function () {
    companyCustomizationsApi.getCustomerMessagesSettings($stateParams.id)
    .then(( settings : CustomerMessagesSettingsModel ) => {
      $scope.customerMessagesSettings = settings;
    });

    companyCustomizationsApi.getBrandingGroups()
    .then(( groups : Array<CodeTypeModel>) => {
      $scope.brandingGroups = groups;
    });

    companyCustomizationsApi.getCustomStripeFee($scope.company)
    .then(rate => {
      $scope.customizations = {
        stripeFee: rate
      };
    });
  };

  $scope.saveCustomerMessagesSettings = function () {
    confirm.generic($translate.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CONFIRM_ACTIVATION_VALUES',{
      companyName: $scope.company.company_name
    }))
    .then(() => companyCustomizationsApi.saveCustomerMessagesSettings($scope.customerMessagesSettings))
    .then(() => companyCustomizationsApi.getCustomerMessagesSettings($stateParams.id))
    .then(( settings : CustomerMessagesSettingsModel ) => {
      $scope.customerMessagesSettings = settings;

      messages.show($translate.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.SETTINGS_SAVED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.saveBranding = function () {
    companyCustomizationsApi.saveBranding($scope.company)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.BRANDING'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.saveStripeFee = function () {
    companyCustomizationsApi.saveStripeFee($scope.customizations.stripeFee, $scope.company)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.FEE'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.setDataDefaults = function () {
    confirm.generic(`Continuing will overwrite the company settings and messages for <strong>${$scope.company.company_name}</strong>. Would you like to continue?`)
    .then(() => companyCustomizationsApi.setDataDefaults($scope.company))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DEFAULTS_SET_FOR_BRAND'), 'success');
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.setDefaults = function () {
    confirm.generic(`Continuing will overwrite the company settings and messages for <strong>${$scope.company.company_name}</strong>. Would you like to continue?`)
    .then(() => companyCustomizationsApi.setDefaults($scope.company))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DEFAULTS_SET_FOR_BRAND'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.init();
};
